import { Box } from '@mui/material';
import { MediaCard } from '@core/components';
import { VestmentCategory } from '../../enum/vestmentCategory';
import { ORDER_ITEM_REGISTRY } from '../../utils/orderItem';
import { VESTMENT_CATEGORY_IMAGES } from '../../utils/vestment';

interface VestmentCategoryPickerProps {
  onSelect: (category: VestmentCategory) => void;
}

const VestmentCategoryPicker = ({ onSelect }: VestmentCategoryPickerProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr 1fr',
          sm: 'repeat(4, 1fr)',
        },
        gap: 1.5,
      }}
    >
      {(Object.keys(ORDER_ITEM_REGISTRY) as VestmentCategory[]).map(
        (category) => (
          <MediaCard
            key={category}
            content={ORDER_ITEM_REGISTRY[category].label}
            imageSrc={VESTMENT_CATEGORY_IMAGES[category]}
            imageLoading="eager"
            onClick={() => onSelect(category)}
          />
        )
      )}
    </Box>
  );
};

export default VestmentCategoryPicker;
